import styled from "styled-components";
import {
  COLOR_DEEP_FOREST,
  COLOR_GRAY_GREEN_2,
  COLOR_GRAY_GREEN_3,
  COLOR_TEXT_GRAY,
} from "../../../styles/globalStylesVariables";
import { tokens } from "@manifesthhqinc/ui-library";

export const OuterWrapper = styled.div<{ $show: boolean }>`
  position: absolute;
  width: 100vw;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;

  z-index: 1001;
  ${(props) => (props.$show ? `transform: translateX(0)` : `  transform: translateX(-100%)`)};
  @media screen and (min-width: 768px) {
    width: 360px;
  }
`;

export const NavigationWrapper = styled.div<{ $show: boolean }>`
  position: absolute;
  width: 100%;
  height: 645px;
  bottom: 0;
  left: 0;
  right: 0;
  background: white;
  z-index: 1001;
  transition: all 0.25s ease-in-out;
  padding: 28px 31px 53px 26px;
  ${(props) => (props.$show ? `transform: translateX(0)` : `  transform: translateX(-100%)`)}
`;

export const NavigationContainer = styled.div`
  width: 100%;
  height: 100%;
  background: ${COLOR_GRAY_GREEN_3}
  display: flex;
  flex-direction: column;
`;

export const NavigationHeader = styled.div`
  width: 100%;
  height: 42px;
  position: relative;
  color: ${COLOR_DEEP_FOREST};
  font-size: 20px;

  .navigation-close-button {
    position: absolute;
    top: 9px;
    right: -3px;
  }
`;

export const NavigationHeaderText = styled.div`
  height: 26px;
  vertical-align: middle;
`;

export const NavigationContent = styled.div`
  margin-top: 44px;
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const NavigationItem = styled.button`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  height: 52px;

  cursor: pointer;
  &:hover {
  }
`;

export const NavigationIconDiv = styled.div`
  height: 40px;
  width: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const NavigationIconTextContainer = styled.div<{ $color?: string }>`
  display: flex;
  align-items: center;
  gap: 20px;
  color: ${tokens.color.text[1000]};

  .support-link {
    color: ${tokens.color.brand[700]};
    text-decoration: none;
    width: 300px;
  }

  &:hover {
    color: ${COLOR_DEEP_FOREST};
  }
`;

export const NavigationFooter = styled.div`
  height: 80px;
  width: 100%;
  padding: 10px 20px;
  border-top: 1px solid ${COLOR_GRAY_GREEN_2};
  text-align: center;
  line-height: 30px;
`;

export const HomeTransferPath = styled.div`
  display: inline-flex;
  padding: 5px 16px;
  justify-content: center;
  align-items: center;
  gap: 16px;
  font-size: 12px;

  border-radius: 22px;
  border: 1px solid var(--Gray-Green-100, #c3cac9);
  background: var(--Gray-Green-30, #f8f8f8);
  color: ${COLOR_TEXT_GRAY};
`;

export const InProgressTransferDiv = styled.div`
  padding: 22px 25px;
  border-radius: 6px;
  background: white;
  margin-top: 18px;
  box-shadow: 2px 2px 20px rgba(0, 0, 0, 0.05);
  tr {
    td {
      padding-bottom: 14px;
    }
    &:last-child {
      td {
        padding-bottom: 0px;
      }
    }
  }

  .table__label {
    width: 80px;
  }
`;

export const TileContainer = styled.div`
  margin-top: 32px;
`;

export const TransferContinueCard = styled.div`
  width: 100%;
  padding: 20px;
  background: white;
  border-radius: 8px;
  box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.05);
  display: flex;
  flex-direction: column;
  gap: 20px;
`;
